import React from 'react'

const NoteCard = ({ title, text }) => {
    return (
        <>
            <div className='note-div'>
                <span className='text'><b>{title}</b> {text}</span>
            </div>
            <style jsx>{`
                .note-div{
                    padding: 10px 20px;
                    border: 1px solid #E2E2E2;
                    background: #F8F8F8;
                    border-radius: 5px;
                }
                .text{
                    font-family: Hind;
                    font-size: 15px;
                    font-weight: 500;
                    line-height: 24.02px;
                    color: #333333;
                }
             `}</style>
        </>
    )
}

export default NoteCard